// extracted by mini-css-extract-plugin
module.exports = {"menu":"style_menu__2SU7n","item":"style_item__1Dv3b","activeTab":"style_activeTab__29GV_"};